import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AlertBlockSuccess, Typography } from '@klarna/bubble-ui';
import { VerticalRhythm } from 'mage-components';

import Button from '@/components/Button';
import Instructions from './Instructions';

const tPrefix = 'products-fe.pages.whats_next_page.store_connected';

const Completed = ({ t }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <>
      <Typography textToken="text-style/headings/blocks/bold/primary">
        {t(`${tPrefix}.title`)}
      </Typography>
      <VerticalRhythm spacing={6} />
      <Typography textToken="text-style/headings/blocks/medium/tertiary">
        {t(`${tPrefix}.subtitle`)}
      </Typography>
      <VerticalRhythm spacing={6} />
      <AlertBlockSuccess
        iconType={() => null}
        title={
          <Typography textToken="text-style/headings/blocks/bold/grande">
            {t(`${tPrefix}.status_messsage.title`)}
          </Typography>
        }
        content={[
          <>
            <VerticalRhythm spacing={4} />
            <Typography textToken="text-style/text/super-paragraphs/body/regular">
              {t(`${tPrefix}.status_messsage.subtitle`)}
            </Typography>
          </>,
        ]}
      />
      <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
      <div style={{ alignItems: 'flex-start' }}>
        <Button
          size="medium"
          type="quaternary"
          onClick={() => setShowInstructions(!showInstructions)}
        >
          {t(`${tPrefix}.status_messsage.button_text.${showInstructions ? 'hidden' : 'shown'}`)}
        </Button>
      </div>
      <VerticalRhythm spacing={6} />
      {showInstructions && <Instructions />}
      <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
    </>
  );
};

Completed.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Completed;
